import { api, LightningElement, wire } from "lwc";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import type { ToastVariant } from "./types";
import * as locales from "./locales";
import { Config } from "tds/sanitizedHtml";
import DOMPurify from "dompurify";

export type { ToastVariant };

const icons = {
  info: "info",
  warning: "warning",
  success: "success",
  error: "error",
};

export const defaultHtmlConfig: Config = {
  ALLOWED_TAGS: ["a", "strong", "em"],
};

export default class extends LightningElement {
  @api variant: ToastVariant = "info";
  @api message: string = undefined!;
  @api unsafeMessage: string = undefined!;
  @api htmlConfig: Config = defaultHtmlConfig;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  private get isUnsafe() {
    return !this.message && this.unsafeMessage;
  }

  private get iconAssistiveText() {
    // eslint-disable-next-line
    return this.labels[this.variant] || this.labels.info;
  }

  private get iconSymbol() {
    return icons[this.variant] || icons.info;
  }

  private get className() {
    return `toast toast--${this.variant}`;
  }

  private toastMessage() {
    return this.unsafeMessage
      ? DOMPurify.sanitize(this.unsafeMessage, {
          USE_PROFILES: { html: false },
        })
      : this.message;
  }

  renderedCallback() {
    window.dispatchEvent(
      new CustomEvent("displaytoastmessage", {
        detail: { message: this.toastMessage() },
      })
    );

    const messageElement = this.template.querySelector(
      ".message"
    ) as HTMLElement;
    if (messageElement) {
      messageElement.focus();
    }
  }

  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
}
